<rt-box [hasHoverState]="!disabled" variant="padding-small" [class.disabled]="disabled">
  <rt-icon [name]="icon" size="medium" margin-right></rt-icon>
  <div layout-vertical layout-flex-1-1>
    <div>
      <rt-heading>{{ heading }}</rt-heading>
      @if (badgeText) {
        <rt-badge [color]="badgeVariant" [text]="badgeText" margin-left-small-x></rt-badge>
      }
    </div>
    <rt-heading variant="subheading normal">{{ subheading }}</rt-heading>
  </div>
  @if (!disabled) {
    <div>
      <rt-icon [name]="'chevron-right'" class="arrow-icon"></rt-icon>
    </div>
  }
</rt-box>
